<template>
    <div class="row form-group">
        <div class="col col-md-3">
            <label for="text-input" class="form-control-label">
                <span class="input-required" v-if="isRequired" span>*</span>
                <span v-else>&nbsp;&nbsp;</span>
                {{label}}
            </label>
        </div>
        <div class="col-12 col-md-9">
            <input
                class="form-control"
                :placeholder="placeholder"
                :type="type"
                :value="value"
                :disabled="disabled"
                @input="$emit('input', $event.target.value)"
            >
            <slot name="message-bottom"></slot>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  }
}
</script>
